<template>
<div class="chapter">
<div class="inner_page">
<div class="ContentsPage">
<h1 id="heading_id_2">Contents</h1>
<p><a href="#/Text/Preface">Preface</a></p>
<div class="Space">
<p><a href="#/Text/Introduction">Introduction</a></p>
</div>
<div class="Space">
<p><a href="#/Text/Introduction#BibleOneBook">The Bible is one book</a></p>
<p><a href="#/Text/Introduction#KingdomGod">The kingdom of God</a></p>
</div>
<ol>
<li>
<p><span href="#/Text/Chapter1" title="Link target outside of Sample"><span class="ChapterTitle">The pattern of the kingdom</span></span></p>
<p>Bible study: Genesis 1:1 – 2:25</p>
</li>
<li>
<p><span href="#/Text/Chapter2" title="Link target outside of Sample"><span class="ChapterTitle">The perished kingdom</span></span></p>
<p>Bible study: Genesis 3</p>
</li>
<li>
<p><span href="#/Text/Chapter3" title="Link target outside of Sample"><span class="ChapterTitle">The promised kingdom</span></span></p>
<p>Bible study: Genesis 17:1–8; Galatians 3:6–14</p>
</li>
<li>
<p><span href="#/Text/Chapter4" title="Link target outside of Sample"><span class="ChapterTitle">The partial kingdom</span></span></p>
<p>God’s people: Genesis 12 – Exodus 18</p>
<p>God’s rule and blessing</p>
<p>Bible study: Exodus 19:1–13; 20:1–17</p>
<p>God’s place</p>
<p>God’s king</p>
<p>Bible study: 2 Samuel 7:1–17</p>
</li>
<li>
<p><span href="#/Text/Chapter5" title="Link target outside of Sample"><span class="ChapterTitle">The prophesied kingdom</span></span></p>
<p>Bible study: Hosea 1 – 3</p>
</li>
<li>
<p><span href="#/Text/Chapter6" title="Link target outside of Sample"><span class="ChapterTitle">The present kingdom</span></span></p>
<p>Bible study: Luke 1:39–80; 2:25–32</p>
</li>
<li>
<p><span href="#/Text/Chapter7" title="Link target outside of Sample"><span class="ChapterTitle">The proclaimed kingdom</span></span></p>
<p>Bible study: 2 Corinthians 4</p>
</li>
<li>
<p><span href="#/Text/Chapter8" title="Link target outside of Sample"><span class="ChapterTitle">The perfected kingdom</span></span></p>
<p>Bible study: Revelation 21:1–8; 21:22 – 22:5</p>
</li>
</ol>
<div class="Space">
<p><span href="#/Text/Epilogue" title="Link target outside of Sample">Epilogue</span></p>
</div>
<div class="Space">
<p><span href="#/Text/Notes" title="Link target outside of Sample">Notes</span></p>
</div>
<p>If you would like to run a course based on this material, downloadable resources are available from <a href="https://ivpbooks.com/commentaries-and-group-resources" target="_blank">ivpbooks.com/commentaries-and-group-resources</a></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Contents.vue?658740a5